import { Injectable } from '@angular/core';
import { CustomerAddress } from '../interfaces/customeraddress.interface';
import { Customer } from '../interfaces/customer.interface';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class CustomerAddressService {

  private getcustomeraddressUrl = environment.apiUrl + '/handlers/customeraddressesgetall.php';
  private deletecustomeraddressUrl = environment.apiUrl + '/handlers/customeraddressdelete.php';
  private createcustomeraddressUrl = environment.apiUrl + '/handlers/customeraddresscreate.php';
  private updatecustomeraddressUrl = environment.apiUrl + '/handlers/customeraddressupdate.php';

  customeraddresses: CustomerAddress[] = [];
  public customeraddress: CustomerAddress = {} as CustomerAddress;
  public editcustomeraddress: CustomerAddress = {} as CustomerAddress;
  customer: Customer = {} as Customer;

  constructor(private http: HttpClient) { }

  async getCustomeraddresses(customercode: string): Promise<CustomerAddress[]> {
         let cuser = localStorage.getItem('currentUser');
          if (cuser === null) {
            throw new Error('Not logged in');
          }
          let user = JSON.parse(cuser);
          let distid = user['distid'];
          const data$ = this.http.post<CustomerAddress[]>(this.getcustomeraddressUrl,JSON.stringify({ customercode: customercode, distid: distid }))
          try {
            this.customeraddresses = await firstValueFrom(data$);
            return this.customeraddresses;
          }
          catch (error) {
            console.error(
              'get customer addresses', error);
              throw error;
          };  
        }
    async create(customercode: string, addressserial: string,salesareacode:string, subsectorcode: string, accountcode: string, ordercode: string, addressline1: string, addressline2: string, addresszip: string, uploaded: string): Promise<CustomerAddress> 
    {
      let cuser = localStorage.getItem('currentUser');
      if (cuser === null) 
      {
        throw new Error('Not logged in');
      }
      let user = JSON.parse(cuser);
      let distid = user['distid'];
      const data$ = this.http.post<CustomerAddress>(this.createcustomeraddressUrl, JSON.stringify({customercode: customercode,addressserial: addressserial, salesareacode: salesareacode, subsectorcode: subsectorcode, accountcode:accountcode,ordercode:ordercode,addressline1:addressline1,addressline2:addressline2, addresszip:addresszip, uploaded:uploaded, distid: distid}))
      try 
      {
        this.customeraddress = await firstValueFrom(data$);
        return this.customeraddress;
      }
      catch (error) 
      {
        console.error(
              'customer address create', error);
        throw error;
      };  
  }

  async delete(id: number): Promise<void> {
    let cuser = localStorage.getItem('currentUser');
    if (cuser === null) {
      throw new Error('Not logged in');
    }
    let user = JSON.parse(cuser);
    let distid = user['distid'];
    
    try 
    {
      const data$ = this.http.post(this.deletecustomeraddressUrl,JSON.stringify({id: id, distid: distid }))
      let response = await firstValueFrom(data$);
      return;
    }
    catch (error) 
    {
      console.error(
              'customer address delete!', error);
              throw error;
    };  
   }   

    async updateCustomerAddress(customercode: string, addressserial: string, salesareacode: string, subsectorcode: string, accountcode: string, ordercode: string, addressline1: string, addressline2: string, addresszip: string, uploaded: string, id: number): Promise<void> 
    {
    let cuser = localStorage.getItem('currentUser');
    if (cuser === null) {
      throw new Error('Not logged in');
    }
    let user = JSON.parse(cuser);
    let distid = user['distid'];

      try {
          const data$ = await this.http.post(this.updatecustomeraddressUrl, JSON.stringify({customercode: customercode, addressserial: addressserial, salesareacode:salesareacode, subsectorcode: subsectorcode, accountcode: accountcode,ordercode:ordercode,addressline1:addressline1,addressline2:addressline2, addresszip:addresszip, uploaded:uploaded, distid: distid, id: id}))
          let response = await firstValueFrom(data$);
          return;
      }
      catch (error) 
    {
      console.error(
              'customer address delete!', error);
              throw error;
    };  

  } 

}
